var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hideFrame",attrs:{"id":'frame'+_vm.id}},[_c('iframe',{staticClass:"video",attrs:{"src":'https://player.vimeo.com/video/'+_vm.url,"width":"100%","height":"200","frameborder":"0","allow":"autoplay; fullscreen","allowfullscreen":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df640b18","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Frame.vue
// module id = null
// module chunks = 